// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"906b91ba","204":"494567da","209":"808c8814","230":"9c29c59f","521":"17ed018f","643":"16a31552","825":"f0fc9385"}[chunkId] + ".chunk.js";
};